import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { GeneralDialogResultComponent } from './general-dialog-result/general-dialog-result.component';

@Component({
  selector: 'general-dialog',
  templateUrl: './general-dialog.component.html'
})
export class GeneralDialogComponent {
  public selectedOption: string;
  public dialogConfig: MatDialogConfig;

  @Input() buttonTitle: string;
  @Input() dialogHeader: string;
  @Input() dialogText: string;
  @Input() dialogType: string;
  @Input() dialogList: Array<object>;
  @Input() dialogImageClass: any;
  @Input() dialogOptions: any;
  @Input() dialogIcon: string;

  @Output() changeSelectedOption: EventEmitter<any> = new EventEmitter();

  constructor(public dialog: MatDialog) {
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.disableClose = true;

    // TODO: the hasBackdrop property is supposedly going to be part of the next Material2 release.
    // TODO: might have to move into the openDialog() method.
    // if (this.dialogType === 'whatsThis') {
    //   this.dialogConfig.hasBackdrop = false;
    // }
  }

  public openDialog() {
    const dialogRef = this.dialog.open(GeneralDialogResultComponent, this.dialogConfig);
    dialogRef.componentInstance.dialogHeader = this.dialogHeader;
    dialogRef.componentInstance.dialogText = this.dialogText;
    dialogRef.componentInstance.dialogType = this.dialogType;
    dialogRef.componentInstance.dialogList = this.dialogList;
    dialogRef.componentInstance.dialogImageClass = this.dialogImageClass;
    dialogRef.componentInstance.dialogOptions = this.dialogOptions;

    dialogRef.afterClosed()
      .subscribe(result => {
        if (result) {
          this.selectedOption = result;
          this.changeSelectedOption.emit(this.selectedOption);
        }
      });
  }

}
